// Transform 8 Weeks section animation
// - Counts from 0% to target
// - Animates circular progress stroke from 0 to full circumference

(function () {
  var section = document.getElementById('transform-8-weeks');
  if (!section) return;

  var stats = Array.prototype.slice.call(section.querySelectorAll('.transform8__stat'));
  if (!stats.length) return;

  var circumference = 2 * Math.PI * 54; // r = 54 per CSS/SVG

  function animateStat(statEl) {
    if (statEl.__animated) return; // guard
    statEl.__animated = true;

    var target = parseInt(statEl.getAttribute('data-target') || '100', 10);
    var circle = statEl.querySelector('.transform8__circle');
    var percentEl = statEl.querySelector('.transform8__percent');

    var startTs = null;
    var duration = 1200; // ms

    function frame(ts) {
      if (!startTs) startTs = ts;
      var progress = Math.min(1, (ts - startTs) / duration);

      var current = Math.floor(progress * target);
      percentEl.textContent = current + '%';

      var offset = circumference * (1 - progress);
      circle.style.strokeDashoffset = String(offset);

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        percentEl.textContent = target + '%';
        circle.style.strokeDashoffset = '0';
      }
    }

    // initialize to 0
    circle.style.strokeDasharray = String(circumference);
    circle.style.strokeDashoffset = String(circumference);
    percentEl.textContent = '0%';
    requestAnimationFrame(frame);
  }

  // Observe when the stats container enters viewport
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        stats.forEach(animateStat);
        observer.disconnect();
      }
    });
  }, {
    root: null,
    threshold: 0.25
  });

  observer.observe(section);
})();


